import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionEyebrow } from "./SectionEyebrow";
import { SECTIONS } from "../../pages/FAQ";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const pick = (sectionId, index = 0) =>
  SECTIONS.find((s) => s.id === sectionId)?.faqs[index];

const TEASER_FAQS = [
  pick("about", 0),      // What is Clinq Africa?
  pick("pricing", 0),    // What does it cost to use Clinq?
  pick("score", 0),      // What is the Capital Readiness Score?
  pick("funders", 0),    // How does Clinq connect me with funders?
].filter(Boolean);

export const FAQTeaser = () => (
  <section data-testid="landing-faq-teaser" className="bg-[#F4F8F8] text-neutral-900">
    <div className="mx-auto max-w-4xl px-6 py-20 lg:py-28">
      <SectionEyebrow testid="faq-teaser-eyebrow">Questions, answered</SectionEyebrow>
      <h2 className="mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl"
        style={{ fontFamily: "Manrope, sans-serif" }}>
        Frequently asked <span className="text-[#0A8B85]">questions</span>
      </h2>
      <p className="mt-4 max-w-xl text-base leading-relaxed text-neutral-600">
        The four things business owners ask us most before getting started.
      </p>

      <Accordion type="single" collapsible className="mt-8">
        {TEASER_FAQS.map((f, i) => (
          <AccordionItem key={i} value={`teaser-${i}`}
            data-testid={`faq-teaser-item-${i}`}
            className="border-neutral-200">
            <AccordionTrigger className="text-left text-[15px] font-bold text-neutral-800 hover:text-[#0A8B85] hover:no-underline sm:text-base">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-neutral-700">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <Link to="/faq" data-testid="faq-teaser-see-all"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0A8B85] px-6 py-3 text-sm font-bold text-white transition-opacity hover:opacity-90">
        See all FAQs <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </section>
);
